// extracted by mini-css-extract-plugin
export default {"content-box":"MyInfoWrite_content-box__pm+yB","inner-box":"MyInfoWrite_inner-box__LynxD","right":"MyInfoWrite_right__HGqBQ","btn-group":"MyInfoWrite_btn-group__S1duL"};